<template>
    <div @click="$emit('cancel')" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
    </div>

    <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
        <div class="flex flex-col justify-center  z-40 bg-white w-[1000px] text-lg rounded-lg border-[2px] border-[#0B6014]">
            <div class="pafcpic_header bg-[#016B00] py-3 px-6">
                <p class="text-[#ffffff] text-md font-bold">TRAINING REQUISITION REQUEST</p>
            </div>
            <div class="pafcpic_body py-6 px-6">
                <p class="text-green-800"></p>
                <table>
                    <tr>
                        <td class="text-sm font-medium text-[#0B6014]">Reference No.:</td>
                        <td class="text-sm font-medium">:</td>
                        <td class="text-sm">{{ Data.trainingKey }}</td>
                    </tr>
                    <tr>
                        <td class="text-sm font-medium text-[#0B6014]">Name</td>
                        <td class="text-sm font-medium pr-11 text-[#0B6014]">:</td>
                        <td class="text-sm ">{{ Data.full_name }}</td>
                      
                    </tr>
                    <tr>
                        <td class="text-sm font-medium text-[#0B6014]">Date Submitted</td>
                        <td class="text-sm font-medium">:</td>
                        <td class="text-sm">{{ Data.dateSubmitted }}</td>
                    </tr>
                    <tr>
                        <td class="text-sm font-medium text-[#0B6014]">Training Category</td>
                        <td class="text-sm font-medium">:</td>
                        <td class="text-sm">
                            <span v-if="Data.trainingCategory == 1">
                                HLRD RECOMMENDED TRAINING
                            </span>
                            <span v-if="Data.trainingCategory == 2">
                                Employee Iniated Training
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-sm font-medium text-[#0B6014]">Training Type</td>
                        <td class="text-sm font-medium">:</td>
                        <td class="text-sm">
                            <span v-if="Data.trainingType   == 1">
                                Technical/Technology Training
                            </span>
                            <span v-if="Data.trainingType   == 2">
                                Quality Training
                            </span>
                            <span v-if="Data.trainingType   == 3">
                                Skills Training
                            </span>
                            <span v-if="Data.trainingType   == 4">
                                Others
                            </span>
                        </td>
                    </tr>
                </table>
                <div v-if="Data.trainingCategory === '2'" class="flex flex-col  gap- mt-3" >
                    <div class="bg-[#016B00] py-3 ">
                      <h1 class="text-xs text-[#ffffff] font-semibold px-5">
                        Employee Initiated Training
                      </h1>
                    </div>
                      <div class="flex flex-col  gap-1 py-5 px-4 h-[300px] overflow-auto">
                        <div class="grid grid-cols-1 gap-3 py-2 ">
                          <div class="bg-[#24723bb7] w-[170px] px-4 flex rounded-md gap-3 py-3 justify-center items-center mb-3">
                            <p class=" text-white text-xs">Training (Days):</p>
                            <p class="text-sm text-white">{{ Data.days }}</p>
                          </div>
                          <div class="flex justify-between items-center  bg-[#747373] rounded-xl py-1 px-4 text-xs text-[#ebebeb]  w-[45%] hover:bg-[#464545] " v-for="(row,index) in alldate" :key="index" @click="removeItem(index)">
                                <div class="font-semibold flex gap-2">
                                    <span>Date From :{{ row.fromdate }}</span>
                                    <span>|</span>
                                    <span>Date To :{{ row.todate }}</span>
                                    <span>|</span>
                                    <span>Time From :{{ row.fromtime }}</span>
                                    <span>|</span>
                                    <span>Time To :{{ row.totime }}</span>
                                </div>
                                <div class="rounded-full bg-[#6d6d6d] px-3 py-2">
                                    <span class=" font-semibold text-xs">X</span>
                                 </div>
                          </div>
                         </div>
                          <div>
                            <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Topic of the training</p>
                            <input type="text" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" :value="Data.topic" disabled >
                          </div>
                          
                          <div class="grid grid-cols-2 gap-4">
                              <div class="col-span-1"> 
                                  <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Training Location/ Venue</p>
                                  <input type="input" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" placeholder="0" :value="Data.location" disabled>
                              </div>
                              <div class="col-span-1"> 
                                  <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Training Provider</p>
                                  <input type="input" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" placeholder="0"  :value="Data.provider" disabled>
                              </div>
                          </div>
                          <div class="grid grid-cols-4 gap-4">
                              <div class="col-span-1"> 
                                  <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Contact Person</p>
                                  <input type="input" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" placeholder="0" :value="Data.contact"  disabled>
                              </div>
                              <div class="col-span-1"> 
                                  <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Contact Details</p>
                                  <input type="input" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" placeholder="0"  :value="Data.contact_cpno"  disabled>
                              </div>
                              <div class="col-span-1"> 
                                <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Mode of Payment</p>
                                <select class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" :value="Data.payment_mode" disabled>
                                    <option value='' selected disabled>SELECT MODE OF PAYMENT</option>
                                    <option value="CASH">CASH</option>
                                    <option value="CHEQUE">CHEQUE</option>
                                </select>
                            </div>
                              <div class="col-span-1"> 
                                  <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Amount</p>
                                  <input type="input" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" placeholder="0" :value="Data.amount" disabled>
                              </div>
                          </div>
                          <div class="grid grid-cols-3 gap-4">
                             <div class="col-span-1"> 
                                  <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Bank Name</p>
                                  <input type="input" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" placeholder="0" :value="Data.bank" disabled>
                              </div>
                              <div class="col-span-1"> 
                                <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Account Name</p>
                                <input type="input" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" placeholder="0" :value="Data.account_name" disabled>
                              </div>
                              <div class="col-span-1"> 
                                <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Account Number</p>
                                <input type="input" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" placeholder="0" :value="Data.account_no" disabled>
                              </div>    
                          </div>
                          <div class="grid grid-cols-3 gap-4">
                            <div class="col-span-1"> 
                                 <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Service Provider Registered Name</p>
                                 <input type="input" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" placeholder="0" :value="Data.reg_name" disabled>
                             </div>
                             <div class="col-span-1"> 
                               <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Service Provider Tin Number</p>
                               <input type="input" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" placeholder="0" :value="Data.tin" disabled>
                             </div>
                             <div class="col-span-1"> 
                               <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Service Provider Registration</p>
                               <select class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" :value="Data.reg_type" disabled>
                                  <option value="VATABLE" disabled>VATABLE</option>
                                  <option value="NON-VATABLE" disabled>NON-VATABLE</option>
                                </select>
                             </div>
                             <div class="col-span-3"> 
                                <p class="text-xs text-[#868585] mb-1 ml-1 font-medium">Special Instruction(s)</p>
                                <input type="input" class="rounded-md text-[#494949] border-[#cccccc] py-2 px-2 border w-full text-sm outline-[#016B00]" placeholder="0" :value="Data.sp_instruction" disabled>
                            </div>    
                         </div>
                      </div>
                  </div>
            </div>
            <div class=" py-5 border-[#b6b5b5] border-t border-b px-6">
                <div class="flex gap-5">
                    <div class="w-full flex flex-col gap-2">
                      <label class="text-sm text-[#6A6A6A] font-semibold">Recommended by:</label>
                        <div v-if="recommendation == null">
                          <p class="text-sm text-[#6A6A6A]">NO SIGNATORY FOUND</p>
                        </div>
                        <div v-else v-for="(recon,index) in recommendation" :key="index" class="">
                          <p class="text-sm font-semibold  " :class="{'text-[#016B00]': recon.status === 'A','text-[#792424]': recon.status == 'D','text-[#8d8d8d]': !recon.status}">{{recon.employee_name}}</p>
                          <label class="text-sm text-[#6A6A6A]">Immediate Superior</label>
                          <div v-if="approval.status == 'D'">
                            <label class="text-xs font-semibold text-[#6A6A6A]">Remarks:</label>
                            <p class="text-sm font-semibold text-[#792424]"> {{approval.remarks}}</p>
                          </div>
                        </div>
                    </div>
                    <div class=" w-full flex flex-col gap-2">
                      
                      <label class="text-sm text-[#6A6A6A] font-semibold">Approved by:</label>
                      <div v-if="approval == null">
                        <p class="text-sm text-[#6A6A6A]">NO SIGNATORY FOUND</p>
                      </div>
                      <div v-else v-for="(approval,index) in approval" :key="index" class="">
                        <div v-if="approval != null">
                            <div class="flex relative w-auto">
                                <p class="text-sm font-semibold " :class="{'text-[#016B00]': approval.status == 'A','text-[#792424]': approval.status == 'D','text-[#8d8d8d]': !approval.status}">{{approval.employee_name}}</p>
                                <!-- <img v-if="approval.status == 'A'" src="../../assets/signature.png" class="w-[80px] absolute   left-10 right-0"> -->
                            </div>
                         
                          <label class="text-sm text-[#6A6A6A]">Division / Office Executive</label>
                          <div v-if="approval.status == 'D'">
                            <label class="text-xs font-semibold text-[#6A6A6A]">Remarks:</label>
                            <p class="text-sm font-semibold text-[#792424]"> {{approval.remarks}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>

              
        <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
            <div class="flex gap-3" v-if="Data.training_status === 'PB'">
                <button class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md w-[150px]"      @click="$emit('Process',Data.trainingKey,Data.training_status)"> PROCESS   </button>
                <button class="text-sm text-[#ffffff] bg-[#9b2b2b] py-1.5 px-7 rounded-md w-[150px]"  @click="$emit('Disapprove',Data.trainingKey)">    DISAPPROVE </button>
            </div>
            <div class="flex gap-3" v-if="Data.training_status === 'RB'">
                <button class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md w-[150px]"      @click="$emit('Recommend',Data.trainingKey,Data.training_status)"> RECOMMEND   </button>
                <button class="text-sm text-[#ffffff] bg-[#9b2b2b] py-1.5 px-7 rounded-md w-[150px]"  @click="$emit('Disapprove',Data.trainingKey)">    DISAPPROVE </button>
            </div>
            <div class="flex gap-3" v-if="Data.training_status === 'AB'">
                <button class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md w-[150px]"      @click="$emit('Approve',Data.trainingKey,Data.training_status)"> APPROVE   </button>
                <button class="text-sm text-[#ffffff] bg-[#9b2b2b] py-1.5 px-7 rounded-md w-[150px]"  @click="$emit('Disapprove',Data.trainingKey)">    DISAPPROVE </button>
            </div>

            <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[150px]" @click="$emit('cancel')" >Close</button>
        </div>
    </div>

</div>

</template>

<script>

import { defineComponent } from "vue";
import  Services from "../../../services/admin"

export default defineComponent({
components: {
   
},
data() {
    return {
        trainKey:'',
        signatory: null,
        recommendation:null,
        approval:null,
    }
},
props: {
    Data: {
        type: Object,
        default: null,
    },
    Approval:{
        type : Boolean,
        default: false,
    },
    approvalType:{
        type : String,
        
    },
},
mounted(){
    
        this.trainKey = this.Data.trainingKey
        this.getTrainingSignatory()
},
methods:{
        async getTrainingSignatory(){

            const success         = await Services.trainingSignatory(this.trainKey);
            this.signatory        = success.data

            if(this.signatory!=null ){

                this.recommendation = this.signatory.filter(signatory=>signatory.rank == 'R')
                this.approval       = this.signatory.filter(signatory=>signatory.rank == 'A')

                if(this.approval.length == 0){
                    this.approval       = null
                    this.recommendation = null
                }
            }
        },
        
    }
})

</script>